var ELEMENT_ID = 'eas-toast';
function show(t1, t2) {
  var duration = t2 || t1.duration || 1500;
  var message = typeof t1 === 'string' ? t1 : t1.message;
  var current = document.getElementById(ELEMENT_ID);
  var className = typeof t1 !== 'string' && t1.loading ? 'eas-toast toast__loading' : 'eas-toast';
  var loading = typeof t1 !== 'string' && t1.loading;
  if (current) {
    if (current.innerText !== message) {
      current.innerText = message;
    }
    if (current.className !== className) {
      current.className = className;
      if (loading) appendMask();else clearMask();
    }
  } else {
    var elm_1 = document.createElement('div');
    elm_1.id = ELEMENT_ID;
    elm_1.className = className;
    elm_1.innerText = message;
    if (loading) appendMask();
    document.body.appendChild(elm_1);
    setTimeout(function () {
      elm_1.style.opacity = '1';
    }, 10);
  }
  lazyhide(duration);
}
function loading(message, duration) {
  show({
    message: message,
    loading: true,
    duration: duration || 1500
  });
}
function appendMask() {
  var elm = document.createElement('div');
  elm.id = 'toast__mask';
  elm.className = 'eas-toast__mask';
  document.body.appendChild(elm);
}
function clearMask() {
  var mask = document.getElementById('toast__mask');
  if (mask) document.body.removeChild(mask);
}
function hide() {
  clearMask();
  var elm = document.getElementById(ELEMENT_ID);
  if (elm) {
    if (elm.style.opacity === '0') return;
    elm.style.opacity = '0';
    setTimeout(function () {
      document.body.removeChild(elm);
    }, 310);
  }
}
var lazyhide = function () {
  var timer = null;
  return function fn(duration) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(function () {
      hide();
    }, duration);
  };
}();
var createInstance = function createInstance() {
  var ctx = new Object();
  var instance = show.bind(ctx);
  instance.show = show.bind(ctx);
  instance.hide = hide.bind(ctx);
  instance.loading = loading.bind(ctx);
  return instance;
};
var instance = createInstance();
export default instance;